var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMobility = function SvgMobility(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 58 65"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#mobility_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#mobility_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D2007D",
    d: "M4 0h50v54a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8C1E78",
    d: "m-19.387 3.778 21.68 16.91-43.976 2.425 1.602 29.032 24.984-1.379C-6.02 42.702 4.93 37.472 17.056 36.23c13.645-1.404 27.16 2.334 39.102 10.606l16.59-.916-1.602-29.031-30.931 1.706-11.318-9.183L41.893-1.072a95.37 95.37 0 0 0-61.274 4.85z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M29.32 15.27a2.884 2.884 0 1 1-5.766 0 2.884 2.884 0 0 1 5.767 0M41.46 37.223l-4.807-6.729a1.92 1.92 0 0 0-1.564-.805h-6.73V23.92h5.768a1.923 1.923 0 0 0 0-3.845h-7.69A1.92 1.92 0 0 0 24.514 22v9.613a1.92 1.92 0 0 0 1.923 1.922h7.662l4.232 5.924a1.922 1.922 0 0 0 3.128-2.235"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M32.396 35.138a1.923 1.923 0 0 0-2.628.702 4.875 4.875 0 1 1-7.473-6.07 1.923 1.923 0 1 0-2.565-2.866 8.722 8.722 0 1 0 13.367 10.862 1.923 1.923 0 0 0-.702-2.627"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "mobility_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4 0h50v54a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "mobility_svg__a",
    width: 58,
    height: 65,
    x: 0,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2985_11381"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_2985_11381",
    result: "shape"
  })))));
};
export default SvgMobility;